module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign-gift500_e0f692455bbea54cec56ccf6ef5095f7.png";